import { useSelector } from 'react-redux';
import { TcsmStates } from '../../../../../root/tcsm-model';
import { MemberGhlEnrollment } from '../member/models/member-coverage-model';



export function useCurrentGhlFormId() {
	const ghlForms = useSelector<TcsmStates, MemberGhlEnrollment[]>(state => state.newHireEnrollmentState?.memberGhlEnrollments);
	const currentEnrollment = useSelector<TcsmStates, number>(state => state.newHireEnrollmentState?.memberCurrentEmploymentId);

	return ghlForms?.find(form => form?.employment_id === currentEnrollment);
}